export { move } from './moveSelectedReducer';
export { moveAll } from './moveAllReducer';
export { selectItem } from './selectItemReducer';
export { lazyLoad } from './lazyLoadReducer';
export var SHUTTLE_CONTROL_TYPES;
(function (SHUTTLE_CONTROL_TYPES) {
    SHUTTLE_CONTROL_TYPES["MOVE_SELECTIONS"] = "MOVE_SELECTIONS";
    SHUTTLE_CONTROL_TYPES["MOVE_ALL"] = "MOVE_ALL";
    SHUTTLE_CONTROL_TYPES["SELECT_ITEM"] = "SELECT_ITEM";
})(SHUTTLE_CONTROL_TYPES || (SHUTTLE_CONTROL_TYPES = {}));
/**
 * Redux-style composeReducers function. The main difference here
 * is that this function operates on the _same_ slice of state
 * for _all_ reducer functions.
 * @param reducers An object of key: function pairs.
 * @see useShuttleState for usage and other configuration docs.
 */
export const composeReducers = (reducers) => (state, action) => {
    const result = { ...state };
    for (const key in reducers) {
        if (typeof reducers[key] !== 'function') {
            throw new Error(`Reducers must be functions. Saw ${typeof reducers[key]} for ${key}`);
        }
        Object.assign(result, reducers[key](result, action));
    }
    return { ...result };
};
